import clsx from "clsx";
import { BackBtn } from "../button/BackBtn";
import {
  icBackArrowBlack,
  icCartOutline,
  icCartOutlineBlack,
} from "../image/image-src";
import { HeaderCartBtn } from "./HeaderCartBtn";
import { HTMLAttributes } from "react";

export const TopHeading: React.FC<
  HTMLAttributes<HTMLDivElement> & {
    varis?: ("WHITE_CART" | "BLACK_IC" | "STICKY")[];
  }
> = ({ varis, children, className }) => {
  return (
    <div
      className={clsx(
        "flex h-[3.5rem] items-center justify-center px-4 sm:block sm:h-auto sm:justify-start sm:p-0",
        varis?.includes("STICKY") &&
          "absolute left-0 top-0 w-full bg-transparent",
        className,
      )}
    >
      <div className="absolute left-4 my-auto flex sm:hidden">
        <BackBtn
          ic={varis?.includes("BLACK_IC") ? icBackArrowBlack : undefined}
        />
      </div>
      <h1 className="text-lg font-semibold text-gray-900 sm:text-[1.88rem]">
        {children}
      </h1>
      <div className="absolute right-4 my-auto flex sm:hidden">
        <HeaderCartBtn
          vari="SM"
          ic={
            varis?.includes("WHITE_CART") ? icCartOutline : icCartOutlineBlack
          }
          popupClassName="mt-6 mr-0"
        />
      </div>
    </div>
  );
};
